import { Fragment } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

export const RifInformation = ({ detailsFormValues, isOld }) => {
  const {
    subtotalExpenseAutorized,
    subtotalExpenseNotAutorized,
    subtotalIncomesAutorized,
    totalExpensePersonalAutorized,
    taxIVARIF,
    taxISRRIF,
  } = detailsFormValues;
  const { authorizationReport, authorizations } = useSelector(
    (state) => state.authorizationReport
  );

  const considered =
    authorizations.paymentComplementExpensesSubtotal ||
    authorizationReport.paymentComplementExpensesSubtotal ||
    0;
  const consideredExpenseTotalAcreditable =
    parseFloat(subtotalExpenseAutorized) + parseFloat(considered);
  if (isOld) {
    return (
      <div className="col-md-6">
        <strong>Ingresos:</strong>
        <NumberFormat
          value={parseFloat(subtotalIncomesAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones Autorizadas:</strong>
        <NumberFormat
          value={parseFloat(consideredExpenseTotalAcreditable).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones Personales:</strong>
        <NumberFormat
          value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones No Autorizadas:</strong>
        <NumberFormat
          value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        {parseFloat(taxIVARIF.totalIva) >= 0 ? (
          <Fragment>
            <strong>Total a pagar de IVA:</strong>
            <NumberFormat
              value={parseFloat(taxIVARIF.totalIva).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <strong>Total a favor de IVA:</strong>
            <NumberFormat
              value={parseFloat(parseFloat(taxIVARIF.totalIva) * -1).toFixed(6)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
        <strong>Total a pagar de ISR:</strong>
        {parseFloat(taxISRRIF.totalIsr) >= 0 ? (
          <Fragment>
            <NumberFormat
              value={parseFloat(taxISRRIF.totalIsr).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <NumberFormat
              value={parseFloat(0.0).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
            
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table
        className="table table-bordered table-sm mb-0"
        style={{ tableLayout: "auto", whiteSpace: "nowrap" }}
      >
        <thead className="thead-light">
          <tr>
            <th className="align-middle text-center" colSpan={2}>
              Valores RIF
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-weight-bold">Ingresos</td>
            <td>
              <NumberFormat
                value={parseFloat(subtotalIncomesAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Deducciones Autorizadas</td>
            <td>
              <NumberFormat
                value={parseFloat(consideredExpenseTotalAcreditable).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Deducciones Personales</td>
            <td>
              <NumberFormat
                value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">No Autorizadas</td>
            <td>
              <NumberFormat
                value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            {parseFloat(taxIVARIF.totalIva) >= 0 ? (
              <td>
                <span className="font-weight-bold">Total a pagar de IVA</span>
              </td>
            ) : (
              <td>
                <span className="font-weight-bold">Total a favor de IVA</span>
              </td>
            )}
            <td>
              {parseFloat(taxIVARIF.totalIva) >= 0 ? (
                <span>
                  <NumberFormat
                    value={parseFloat(taxIVARIF.totalIva).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              ) : (
                <span>
                  <NumberFormat
                    value={(parseFloat(taxIVARIF.totalIva) * -1).toFixed(6)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              )}
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Total a pagar de ISR:</td>
            <td>
              <NumberFormat
                value={
                  parseFloat(taxISRRIF.totalIsr) >= 0
                    ? parseFloat(taxISRRIF.totalIsr).toFixed(2)
                    : parseFloat(0.0).toFixed(2)
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
